<template>
  <div class="c-filter">
    <div class="c-form">
      <el-form label-width="0" inline class="elementui-common-form-styles" v-highlight @submit.native.prevent>
        <el-form-item>
          <el-input v-model.trim="formData.keyword" :placeholder="placeholder" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search" style="cursor: pointer"></i>
          </el-input>
        </el-form-item>

        <el-form-item v-for="config in selectConfigData" :key="config.id">
          <el-select
            v-model="formData[config.valueKey]"
            :multiple="config.multiple"
            :placeholder="config.placeholder"
            collapse-tags
            filterable
            clearable
            @change="search"
          >
            <el-option v-for="item in dataSourceObj[config.dataKey]" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item class="bg-transparent">
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="btns">
      <el-form label-width="0" inline @submit.native.prevent>
        <el-form-item>
          <el-dropdown @command="batch">
            <el-button>
              批量操作
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="account-export">批量账号导出</el-dropdown-item>
              <el-dropdown-item command="enable">批量启用</el-dropdown-item>
              <el-dropdown-item command="disable">批量禁用</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>

        <el-form-item v-if="hasBatchImportAccountTemplate">
          <el-button @click="emit('on-template')">账号批量导入模板</el-button>
        </el-form-item>

        <el-form-item v-if="hasAccountAutoDisable">
          <el-button @click="emit('on-account-disable')">账号清理提醒配置</el-button>
        </el-form-item>

        <el-form-item v-if="hasBatchImportAccount">
          <el-upload action="" :before-upload="preUpload" accept="application/vnd.ms-excel,.xls,.xlsx,.csv" :show-file-list="false">
            <el-button>批量导入账号</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item v-if="hasAddAccount">
          <slot></slot>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed, getCurrentInstance, onMounted } from 'vue'
import { Message } from 'element-ui'
import { MEDIAS, SYS_USERS } from '@/data/global-opts'
// eslint-disable-next-line
const props = defineProps({
  placeholder: String,
  dataSource: {
    type: Object,
    default: () => ({})
  },
  selectList: {
    type: Array,
    default: () => []
  }
})
// eslint-disable-next-line
const emit = defineEmits(['on-search', 'on-account-export', 'on-enable', 'on-disable', 'on-template', 'on-account-disable', 'on-import'])

const { proxy } = getCurrentInstance()
const store = proxy.$store

// Access Permissions
const access = computed(() => store.state.accessAuth)
const hasAddAccount = computed(() => access.value.includes('M20885'))
const hasBatchImportAccount = computed(() => access.value.includes('M20886'))
const hasBatchImportAccountTemplate = computed(() => access.value.includes('M20887'))
const hasAccountAutoDisable = computed(() => access.value.includes('M20890'))

// Global Data Init
const initGlobalData = () => {
  const requiredItems = [MEDIAS, SYS_USERS].map((p) => ({ payload: p.PAYLOAD, name: p.NAME }))
  store.dispatch('AppData/GET_GLOBAL_OPTS', requiredItems)
}

const mediaData = computed(() => store.getters[`AppData/${MEDIAS.NAME}`])
const opData = computed(() => store.getters[`AppData/${SYS_USERS.NAME}`])

// Data Source
const dataSourceObj = computed(() => ({
  ...props.dataSource,
  mediaData: mediaData.value || [],
  opData: opData.value || []
}))

// Form Data
const formData = reactive({
  keyword: '',
  mediaIds: [],
  opIdList: [],
  agentIds: [],
  accountType: '',
  companyId: '',
  accountStatus: ''
})

const selectConfigData = [
  {
    id: 1,
    placeholder: '选择媒体',
    dataKey: 'mediaData',
    valueKey: 'mediaIds',
    multiple: true
  },
  {
    id: 2,
    placeholder: '选择管理人员',
    dataKey: 'opData',
    valueKey: 'opIdList',
    multiple: true
  },
  {
    id: 3,
    placeholder: '选择代理商',
    dataKey: 'agentData',
    valueKey: 'agentIds',
    multiple: true
  },
  {
    id: 4,
    placeholder: '选择账号状态',
    dataKey: 'accountStatusData',
    valueKey: 'accountStatus',
    multiple: false
  },
  {
    id: 5,
    placeholder: '选择开户主体',
    dataKey: 'companyData',
    valueKey: 'companyId',
    multiple: false
  },
  {
    id: 6,
    placeholder: '选择账号类型',
    dataKey: 'accountTypeData',
    valueKey: 'accountType',
    multiple: false
  }
]

// Methods
const search = () => {
  const params = {
    keyword: formData.keyword,
    mediaIds: formData.mediaIds.join(','),
    opIdList: formData.opIdList.join(','),
    agentIds: formData.agentIds.join(','),
    status: formData.accountStatus,
    companyId: formData.companyId,
    accountType: formData.accountType
  }
  emit('on-search', params)
}

const batch = (command) => {
  if (command !== 'account-export') {
    if (!props.selectList || props.selectList.length === 0) {
      Message.warning('请至少选择一条记录！')
      return
    }
  }
  emit(`on-${command}`) // command is 'enable', 'disable', 'account-export' which matches emit events 'on-enable', etc.
}

const preUpload = (file) => {
  emit('on-import', file)
  return false
}

// Lifecycle
onMounted(() => {
  initGlobalData()
})
</script>

<style lang="scss" scoped>
.btns {
  ::v-deep .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
